import { render, staticRenderFns } from "./BullDeworming.vue?vue&type=template&id=4ebe0140&scoped=true&"
import script from "./BullDeworming.vue?vue&type=script&lang=js&"
export * from "./BullDeworming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe0140",
  null
  
)

export default component.exports